import { AlertTriangle, ShieldCheck } from "lucide-react";

import { Badge } from "@/components/ui/badge";

import type { EnvironmentComparisonRow } from "./environmentComparison";

interface EnvironmentComparisonBadgeProps {
  row: EnvironmentComparisonRow;
}

export function EnvironmentComparisonBadge({
  row,
}: EnvironmentComparisonBadgeProps) {
  switch (row.status) {
    case "different":
      return (
        <Badge variant="destructive">
          <AlertTriangle className="mr-1 size-3" />
          different
        </Badge>
      );
    case "only-stg":
      return <Badge variant="outline">production only</Badge>;
    case "only-staging":
      return <Badge variant="outline">engineering only</Badge>;
    case "protected":
      return (
        <Badge
          variant="secondary"
          title={
            row.protectedMetadataDiffers
              ? "Both values are redacted; their secret storage metadata differs."
              : "Both secrets are configured; redacted values cannot be compared."
          }
        >
          <ShieldCheck className="mr-1 size-3" />
          {row.protectedMetadataDiffers
            ? "protected · store differs"
            : "protected"}
        </Badge>
      );
    case "same":
      return <Badge variant="secondary">same</Badge>;
  }
}
